/**
 * DefaultTreeSingleRenderer — a SingleBlockRenderer for the default tree view
 *
 * This is the "standard" way to render a single kid block: wrap it with
 * PortalShareWrapper and render a <TreeItem>. This mirrors the default
 * rendering path in TreeItem.tsx (lines 408-438).
 *
 * This renderer serves as:
 *   1. The interface definition for SingleBlockRenderer — shows what a
 *      concrete implementation looks like
 *   2. The default singleKidRenderer for the untyped fallback path
 *   3. A reusable renderer that KidRenderingPlugin authors can import
 *      and use inside their custom root renderers
 *
 * When a KidRenderingPlugin sets:
 *   SingleKid: defaultTreeSingleRenderer
 *
 * It means "render each kid the standard way" inside whatever custom
 * container the plugin provides.
 */

import type { SingleBlockRenderer } from '../types'
import { useRel } from '../../data/VMs/RelationVM'
import { PortalShareWrapper } from '../../components/PortalShareInclude'
import { TreeItem } from '../../components/TreeItem'

export const defaultTreeSingleRenderer: SingleBlockRenderer = {
  name: 'default-tree',
  Renderer: (props) => {
    const item = props.item
    if (item.relationID) {
      const rel = useRel(item.relationID)
      return (
        <div>
          <PortalShareWrapper relationID={item.relationID}>
            <TreeItem
              class='sortable-block'
              blockID={rel.block}
              relationID={item.relationID}
            />
          </PortalShareWrapper>
        </div>
      )
    }
    return (
      <div>
        <TreeItem class='sortable-block' {...item} />
      </div>
    )
  },
}
